export const TIME_FORMAT = 'h:mm a';

/**
 * Format a time value to a readable label
 * @param {number|string|null} value - Time value (hours as number or time string)
 * @returns {string|null} Formatted time string or null
 */
export const formatTimeLabel = (value) => {
  if (value == null) return null;

  if (typeof value === 'number') {
    const date = new Date(value * 3600 * 1000);
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    return `${displayHours}:${minutes.toString().padStart(2, '0')} ${period}`;
  }

  return value;
};

/**
 * Format minutes into hours:minutes string
 * @param {number} minutes - Total minutes
 * @returns {string} Formatted time string (e.g., "8:30")
 */
export const formatTotal = (minutes) => {
  if (!minutes) return '0:00';
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours}:${mins.toString().padStart(2, '0')}`;
};

export const DEFAULT_START = '9:00 AM';
export const DEFAULT_END = '5:00 PM';

export const activeStyle = 'bg-primary-500 text-white';
export const inactiveStyle = 'bg-neutral-100 text-neutral-800 border-neutral-200 border-solid';
